import React, { Component } from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import AsideNavbar from '../components/navbars/AsideNavbar'
import Navbars from '../components/navbars/Navbars'
import ProfileSection from '../components/Profile/ProfileSection';
import * as Cookies from "es-cookie";

import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import { withRouter } from "react-router-dom";

import ReactGA from 'react-ga';
import { GoogleAnalyticsArray } from './GoogleAnalytics';

import { STUDENT_GLOBALS } from "../../utils/studentGlobals";
// Inline shimmer skeleton mirroring the profile card + details form.
const ProfileShimmer = () => (
    <div className="py-4">
        <Row>
            <Col xl={4} lg={4} md={12} className="mb-4">
                <Card className="rz-skel-card border-0 text-center">
                    <div className="rz-shimmer rz-skel-circle mx-auto mb-3" style={{ width: '110px', height: '110px' }}></div>
                    <div className="rz-shimmer rz-skel-line mx-auto" style={{ width: '60%' }}></div>
                    <div className="rz-shimmer rz-skel-line sm mx-auto" style={{ width: '40%' }}></div>
                    <div className="rz-shimmer rz-skel-btn mx-auto mt-3" style={{ width: '60%' }}></div>
                </Card>
            </Col>
            <Col xl={8} lg={8} md={12}>
                <Card className="rz-skel-card border-0">
                    <div className="rz-shimmer rz-skel-title" style={{ width: '30%' }}></div>
                    {Array.from({ length: 6 }).map((_, i) => (
                        <Row key={i} className="mb-3">
                            <Col xs={5}><div className="rz-shimmer rz-skel-line mb-0" style={{ width: '70%' }}></div></Col>
                            <Col xs={7}><div className="rz-shimmer rz-skel-line mb-0" style={{ width: '90%' }}></div></Col>
                        </Row>
                    ))}
                </Card>
            </Col>
        </Row>
    </div>
);


const FETCH_ISSTUDENTUSERVALID = gql` 
query($student_user_exam_id: Int!) {
    isStudentUserValid(student_user_exam_id: $student_user_exam_id){
        estatus
        current_plan_id
        expiry_date
        app_version
        user_access_restictions
     }
}

`;
const FETCH_USER_PROFILE = gql` 
query($student_user_exam_id: Int!) {
    getStudentProfile(student_user_exam_id: $student_user_exam_id){
        name
        email
        mobile
        valid
        class_id
        branch_id
        college_name
        institution_id
        institute_name
        profile_pic
        exam_id
        mobile_verified
        target_year
        feedback
        estatus
        branch_name
        section_name
        videos
        user_exams
        {
            exam_type
            hall_ticket_no
        }
     }
}

`;



const UPDATE_STUDENT_ANALYTICS = gql`
mutation(
  $params:AnalyticsStudents1  
  ) {
      studentAnalytics(
      params: $params
   )
}
`;

class Profile extends Component {
    constructor(props){
        super(props)
        this.state={
            submitError:""

        }
    }

    componentDidMount = () => {
        this.addStudentAnalytics();

        const title = GoogleAnalyticsArray[0].Profile;
        ReactGA.pageview('/student/profile',["rizee"], title);
    }

    addStudentAnalytics = e => {
        let addStudentObj = ""

        addStudentObj = {
            exam_id: parseInt(Cookies.get("examid")),
            student_user_exam_id: parseInt(Cookies.get("student_user_exam_id")),
            analytics_module_page_id: 95,
            source: 2
        }
        //console.log("addStudentObj", addStudentObj)

        this.submitpt(
            addStudentObj
        ).catch(error => {
            console.log("catch if error");
            console.log(error);
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message)
            });
        });
    }

    submitpt = async (
        params) => {
        await this.props.submitpt({
            variables: {
                params
            },
        });
    };

    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };

    render() {
        if (Cookies.get("studenttoken") == undefined)
            this.props.history.push("/student/login");

        const getStudentProfile = this.props.getStudentProfile;
        const loading1 = getStudentProfile.loading;
        const error1 = getStudentProfile.error;

        const studentGlobals = this.props.studentGlobals;
        const loading2 = studentGlobals.loading;
        const error2 = studentGlobals.error;

        const isStudentUserValid = this.props.isStudentUserValid;
        const loading5 = isStudentUserValid.loading;
        const error5 = isStudentUserValid.error;

        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }
        if (error2 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }

        if (error5 !== undefined) {
            alert("Server Error. " + error5.message);
            return null;
        }
        //console.log("getUserExplored", isStudentUserValid.isStudentUserValid);
        if (isStudentUserValid.isStudentUserValid != undefined) {
            if (isStudentUserValid.isStudentUserValid.estatus == 0) {
                Cookies.remove("token");
                Cookies.remove("username");
                Cookies.remove("refreshtoken");
                Cookies.remove("email");
                Cookies.remove("id");
                Cookies.remove("institutionid");
                Cookies.remove("userlevel");
                Cookies.remove("name");
                this.props.history.push("/student/login");
            }
        }
        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <Navbars onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">
                    <AsideNavbar onClick={() => this.menuToggler()} />
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper">
                        <Container fluid>
                            {(loading1 == true || loading2 == true || loading5 == true) && (<ProfileShimmer />)}
                            {
                                !loading1 && !loading2 && !loading5 && (
                                    <ProfileSection
                                        getStudentProfile={getStudentProfile.getStudentProfile}
                                        studentGlobals={studentGlobals.studentGlobals}
                                        isStudentUserValid={isStudentUserValid.isStudentUserValid}
                                    />)
                            }

                        </Container>
                    </div>
                </div>
            </div>
        )
    }
}


export default withRouter(compose(
    graphql(FETCH_ISSTUDENTUSERVALID,
        {
            options: props => ({
                variables: {
                    student_user_exam_id: parseInt(Cookies.get("student_user_exam_id"))
                }
                ,
                // Shared cache entry; revalidated on navigation by utils/sessionValidity.
                // Shared studentGlobals union; see utils/studentGlobals.
                fetchPolicy: 'cache-first'
            }), name: "isStudentUserValid"
        }),
    graphql(FETCH_USER_PROFILE,
        {
            options: props => ({
                variables: {
                    student_user_exam_id: parseInt(Cookies.get("student_user_exam_id"))
                },
            }), name: "getStudentProfile"
        }),
    graphql(STUDENT_GLOBALS,
        {
            options: props => ({
                variables: {
                    student_user_exam_id: parseInt(Cookies.get("student_user_exam_id"))
                },
            }), name: "studentGlobals"
        }),
        graphql(UPDATE_STUDENT_ANALYTICS, {
            name: "submitpt"
        }),
        
        )(Profile));
